import dayjs from 'dayjs'
import calc from 'calculatorjs'
import 'dayjs/locale/zh-tw'
import { jyoStatusToName } from '../utils/orderUtils'
import weekday from 'dayjs/plugin/weekday'
import dayOfYear from 'dayjs/plugin/dayOfYear'
import relativeTime from 'dayjs/plugin/relativeTime'
import { dgAmtToProductAmountWith, dgAmtToFeeAmountWith, orderProductAmountNTD, orderFeeAmountNTD, orderDisplayExchRate } from '@g/utils/exchrateDiscount'

dayjs.locale('zh-tw')
dayjs.extend(weekday)
dayjs.extend(dayOfYear)
dayjs.extend(relativeTime)

window.dayjs = dayjs
function parseDate (v) {
  if (!isNaN(v) && String(v).length === 10) {
    v = parseInt(v) * 1000
  }
  return dayjs(v)
}
export function dateFormat (v, formatStr = 'YYYY-MM-DD HH:mm:ss') {
  if (!v) return v
  if (v === '0000-00-00 00:00:00') return ''
  if (v === '0' || v === 0) return ''
  if ((!isNaN(v) && v.length === 10)) {
    v = parseInt(v) * 1000
  }
  if (typeof v === 'number' && String(v).length === 10) {
    v = parseInt(v) * 1000
  }
  return parseDate(v).format(formatStr)
}

export function fromNow (v) {
  return parseDate(v).fromNow().replace(/\s/g, '')
}

export function rangeDateFormat (items, formatStr = 'YYYY-MM-DD') {
  if (items.filter(v => v).length < 2) return
  return items.map(v => dateFormat(v, formatStr)).join(' ~ ')
}

export function phoneFormat (v) {
  if (!v) {
    return v
  }
  if (/^09\d{8}$/.test(v)) {
    return v
  }
  return v.replace(/^(\d{2})(\d+)$/, '$1-$2')
}

export function upyun (v, gmkerl) {
  if (v === null || v === undefined) {
    return v
  }
  v = v.split('#')[0]
  if (/^https?:/.test(v)) {
    // let userAgent = navigator.userAgent
    // if (userAgent.indexOf('Firefox') > -1) {
    //   let str = v.substring(0, v.length - 6)
    //   return str
    // }
    return v
  } else if (/^\/\//.test(v)) {
    return v
  }
  return `https://jyb.upjyb.l-qian.cn${v}${gmkerl || ''}`
}

export function ccmss3 (v) {
  return `https://ccmss3.jyb.com.tw/${v}`
}

export function kdName (v) {
  // // 黑猫
  // if (v.length === 12) {
  //   return '黑猫'
  // }
  // if (v.length === 10) {
  //   return '新竹'
  // }
  // if (v.length < 10) {
  //   return '超商'
  // }
  return 'unknown'
}

export function stCarrierToName (stCarrier) {
  return {
    sf: '順豐速運',
    tcat: '黑貓',
    hct: '新竹',
    van: '專車派件',
    ktj: '大榮',
    ty: '通盈',
    711: '7-11',
    fami: '全家超商',
    tccs: '黑猫超商',
    bld: '便利帶',
    cvs: '超商',
    pch: '網家速配',
    hlj: '',
    taobao: '淘寶',
    1688: '阿里巴巴',
    pinduoduo: '拼多多',
  }[stCarrier]
}

export function addrErrorText (isInvalid) {
  if (isInvalid === '1') {
    return '手機號碼已登記其它姓名，請修正姓名'
  } else if (isInvalid === '2') {
    return '申報人資料為本站黑名單，禁止使用。'
    // return '已被其它用戶登記，如果這是您的手機號碼請立即與客服聯絡'
  } else if (isInvalid === '3') {
    return '身分證字號已登記其它姓名，請修正姓名'
  } else if (isInvalid === '4') {
    return '已被其它用戶登記，如果這是您的身分證字號碼請立即與客服聯絡'
  }
  return '地址錯誤'
}

export function addrStatusErrorText (status) {
  const wrsStatusError = {
    e1: '有塗改痕跡',
    e2: '拍攝不清楚',
    e3: '印章不清晰',
    e4: '非正式印章',
    e5: '委任人與申報人不符',
    e9: '個人申報需親手簽名',
    ea: '缺負責人印章',
    eb: '需填寫負責人姓名',
    ec: '非公司營業登記地址',
    ed: '未按照範例',
    ee: '未填寫申報地址',
    ef: '未填寫戶籍地址',
    eg: '製圖無效',
    eh: '勿填寫日期',
    ei: '請補齊身分證字號/手機號碼',
    ej: '請列印下來簽名蓋章',
    ek: '未拍攝完整',
    el: '請掃描彩色版/拍攝上傳',
    em: '勿反光拍攝',
    en: '勿覆蓋證件資訊',
    eo: '勿加上無關字樣',
    ep: '戶籍地址填寫有誤/不完整',
    eq: '委任人未簽名',
    er: '字跡不清楚',
    es: '字跡太潦草',
  }

  return wrsStatusError[status] || ''
}

export function whsAddrResetErrorText (status) {
  switch (status) {
    case 'e1':
      return '缺少收件暱稱或收件暱稱不正確'
    case 'e2':
      return '手機加密英文代碼(kkrxxxxx)缺少/錯誤'
    case 'e3':
      return '地址後方會員編碼缺少/錯誤'
    case 'e4':
      return '倉庫更改地址'
    case 'e5':
      return '倉庫收件地址或電話有誤'
    default:
      return ''
  }
}

export function toTwb (v) { // 台币
  return isNaN(v) ? v : parseInt(v)
}

export function toRmb (v) { // 台币
  return calc.round(calc(`${v}/4.5`), 1)
}

export function hidePhone (v) { // 隱藏手機號
  if (!v) return v
  return v.replace(/(\d{2})\d{4}(\d{4})/, '$1****$2')
}

export function parcelTwNames (item) {
  const nameList = []
  item.extraInfo.tpTaobaoTradeItems.forEach((tpItem) => {
    if (tpItem.itemMold !== '0' &&
        tpItem.itemTwName &&
        !nameList.find(item2 => item2 === tpItem.itemTwName)
    ) {
      nameList.push(tpItem.itemTwName)
    }
  })
  return nameList.join(',')
}

export function parcelServiceName (type) {
  return {
    sses: '快遞面單拍照',
    reinforce: '包裝氣泡棉',
    unboxing: '內容物拍照',
    oob: '開箱費',
    ooba: '開箱驗貨',
    oobno: '確認型號',
    oobct: '清點數量',
    vaPoweronTest: '通電測試',
    vaWrapBox: '加購紙箱',
    stuffing: '填充氣柱袋',
    woodenSpt: '打木架',
    woodenBox: '打木箱',
    wrapAcb: '包裝氣柱袋',
    splitpri: '包裹拆分',
    oobrm: '移除禁運品',
    woodenSptCov: '拆木架重打胶合板木架',
    specialNeed: '其他需求',
    reoperate: '下架重新入库',
    discountsReoperate: '下架重新入库優惠',
    ippc: '原木燻蒸',
    ctnLbl: '外箱標識拍照',
    td: '運損保價',
  }[type]
}
export function vaTypeName (vaType) {
// fr = 到付運費
// re = 包裝氣泡棉
// st = 填充氣柱袋
// un = 內容物拍照
// oo = 開箱驗貨
// on = 確認型號
// oc = 清點數量
// or = 移除禁運品
// ra = 包裝氣柱袋
// ss = 快遞面單拍照
// ip = 原木薰蒸
// ct = 外箱標識拍照
// ws = 打木架
// wb = 打木箱
// wc = 重打膠合板木架
// sl = 包裹拆分
// ro = 重新入庫上架
// sp = 其他需求
// ob = 開箱費
// ca = 集運訂單更換收件人地址
// du = 稅金
// df = 稅金代收服務費
// cc = 報單
// tp = 更換透明袋
// bx = 更換紙箱
// rb = 加购纸箱（外包装纸箱）
// fx = 補收/補退
// mx = 集運訂單補收尾款
// td = 运损保价
  return {
    fr: '到付運費',
    re: '包裝氣泡棉',
    st: '填充氣柱袋',
    un: '內容物拍照',
    oo: '開箱驗貨',
    on: '確認型號',
    oc: '清點數量',
    or: '移除禁運品',
    ra: '包裝氣柱袋',
    ss: '快遞面單拍照',
    ip: '原木薰蒸',
    ct: '外箱標識拍照',
    ws: '打木架',
    wb: '打木箱',
    wc: '重打膠合板木架',
    sl: '包裹拆分',
    ro: '重新入庫上架',
    sp: '其他需求',
    ob: '開箱費',
    ca: '集運訂單更換收件人地址',
    du: '稅金',
    df: '稅金代收服務費',
    cc: '報單',
    tp: '更換透明袋',
    bx: '更換紙箱',
    rb: '加購紙箱',
    fx: '補收/補退',
    mx: '集運訂單補收尾款',
    td: '運損保價',
  }[vaType]
}

export function ledgerTypeName (type) {
  return {
    J: '集運',
    A: '空運',
    S: '海快',
    V: '附加服務',
    P: '儲值',
    C: '轉寄內地',
    PCL: '金巧幣兌換',
  }[type]
}

export function poweronTestResultName (v) {
  const value = String(v || '')
  if (value.indexOf('po-not-power-on') > -1) {
    return '不正常'
  }
  if (value.indexOf('po-power-on') > -1) {
    return '正常'
  }
  return ''
}

export function vaorderImgName (v) {
  const poweronResultName = poweronTestResultName(v)
  if (poweronResultName) return poweronResultName

  const value = String(v || '')
  const r = /\.(?:\d+[-])?([a-z-0-9]+)\.jpg/.exec(value)
  if (!r) {
    return ''
  }
  const n = r[1]
  const normalizedName = n.replace(/-\d+$/, '')

  if (/^rb-other\d+$/.test(normalizedName)) return '紙箱照片'

  if (n.indexOf('oo-bad') > -1) {
    return '瑕疵照'
  }

  const obj = {
    're-before': '包裝氣泡棉前',
    're-after': '包裝氣泡棉後',

    'un-outer': '外包裝',
    'un-inner': '內包裝',
    'un-front': '商品正面',

    'oo-outer': '外觀照',
    'oo-inner': '內部照',
    'oo-inner2': '內包裝',
    'oo-bad': '瑕疵照',
    'oo-other1': '其他',

    'po-power-on': '正常',
    'po-not-power-on': '不正常',

    // 'st-before': '填充氣柱袋前',
    // 'st-after': '填充氣柱袋後',
    'st-before': '填充前',
    'st-after': '填充後',

    'ws-before': '包裝前',
    'ws-after': '包裝後',

    'ra-before': '包裝前',
    'ra-after': '包裝後',

    'wb-before': '包裝前',
    'wb-after': '包裝後',

    'wc-before': '重打前',
    'wc-after': '重打後',

    'ip-before': '燻蒸前',
    'ip-after': '燻蒸後',

    'or-before': '移除前',
    'or-after': '移除後',
  }

  return obj[n] || obj[normalizedName]
}

export function computItemSumInsured (item) {
  if (item.extraInfo.tpttAmount > 0) {
    return item.extraInfo.tpttAmount
  } else if (item.premiumFee > 0) {
    return item.premiumFee
  } else {
    return 0
  }
}

export function computPremiumFeeTwd (premiumFeeRmb) {
  if (premiumFeeRmb > 0) {
    return Math.max(Math.floor(calc(`${premiumFeeRmb || 0}/20 * 4.4 `)), 1)
  } else {
    return 0
  }
  // return Math.floor(calc(`${premiumFeeRmb || 0}/20 * 4.4 `))
}

export function toKg (value, decimal = 2) {
  return isNaN(value) ? value : Number((value / 1000).toFixed(decimal))
}
export function whsName (value) {
  return {
    1024: '深圳倉',
    2886: '台灣倉',
    2769: '東莞倉',
    1050: '海關監管倉',
    1210: '上海倉',
    1769: '海運家具倉',
    1591: '福州倉',
    1592: '廈門倉',
    1596: '漳州倉',
    2591: '雙11專用倉',
    1598: '三明倉',
    1579: '義烏-漳州倉',
    3591: '平潭倉', // 福州-平潭倉
    3242: '新北新莊店',
    3330: '桃園中路店',
    3406: '台中西屯店',
    3807: '高雄三民店',
    3209: '馬祖自取店',
    3204: '新北倉',
    3433: '台中龍井倉',
    50001: '拼多多',
  }[value]
}

export function seaSrLabelToName (value) {
  return {
    '-': '家具',
    ITEMMOLD4: '家具',
    ITEMMOLD61: '一類',
    ITEMMOLD62: '二類',
    ITEMMOLD63: '三類',
    ITEMMOLD64: '四類',
    ITEMMOLD65: '五類',
    ITEMMOLD66: '六類',
    LGFRAGILE: '易碎品專線',
  }[value]
}

export function whsNameFull (value) {
  // if (value === '3591') {
  //   return '福州-平潭倉'
  // }
  return whsName(value)
}

export function whsNameSimp (value) {
  return {
    1024: '深圳',
    2769: '東莞',
    1050: '監管',
    1210: '上海',
    1769: '家具',
    1591: '福州',
    1592: '廈門',
    1596: '漳州',
    2591: '雙11專用倉',
    1598: '三明',
    1579: '義烏',
    3591: '平潭',
    50001: '拼多多',
  }[value]
}

export function toFixed (v, digits = 2) {
  const valNum = Number(v)
  return isNaN(valNum) ? v : valNum.toFixed(digits)
}

export function numberToLetter (value) {
  return String.fromCharCode(65 + value)
}

export function dgRmbToTwd (value) {
  return Math.round(calc(`${value || 0} * 4.4`))
}

/**
 * 代购金额计算出商品金额
 * @param {*} value
 * @returns
 */
export function dgAmtToProductAmount (value) {
  return Math.round(value / 1.01)
}

/**
 * 代购金额计算出手续费
 * @param {*} value
 * @returns
 */
export function dgAmtToFeeAmount (value) {
  return Math.round(value / 1.01 * 0.01)
}

export default function (Vue) {
  Vue.filter('upyun', upyun)
  Vue.filter('ccmss3', ccmss3)
  Vue.filter('kdName', kdName)
  Vue.filter('dateFormat', dateFormat)
  Vue.filter('fromNow', fromNow)
  Vue.filter('rangeDateFormat', rangeDateFormat)
  Vue.filter('phoneFormat', phoneFormat)
  Vue.filter('stCarrierToName', stCarrierToName)
  Vue.filter('addrErrorText', addrErrorText)
  Vue.filter('addrStatusErrorText', addrStatusErrorText)
  Vue.filter('toTwb', toTwb)
  Vue.filter('toRmb', toRmb)
  Vue.filter('hidePhone', hidePhone)
  Vue.filter('parcelTwNames', parcelTwNames)
  Vue.filter('parcelServiceName', parcelServiceName)
  Vue.filter('ledgerTypeName', ledgerTypeName)
  Vue.filter('vaTypeName', vaTypeName)
  Vue.filter('vaorderImgName', vaorderImgName)

  Vue.filter('computItemSumInsured', computItemSumInsured)
  Vue.filter('computPremiumFeeTwd', computPremiumFeeTwd)
  Vue.filter('toKg', toKg)
  Vue.filter('jyoStatusToName', jyoStatusToName)
  Vue.filter('whsName', whsName)
  Vue.filter('whsNameFull', whsNameFull)
  Vue.filter('whsNameSimp', whsNameSimp)
  Vue.filter('whsAddrResetErrorText', whsAddrResetErrorText)
  Vue.filter('toFixed', toFixed)
  Vue.filter('numberToLetter', numberToLetter)
  Vue.filter('dgRmbToTwd', dgRmbToTwd)
  Vue.filter('seaSrLabelToName', seaSrLabelToName)
  Vue.filter('dgAmtToProductAmount', dgAmtToProductAmount)
  Vue.filter('dgAmtToFeeAmount', dgAmtToFeeAmount)
  Vue.filter('dgAmtToProductAmountWith', dgAmtToProductAmountWith)
  Vue.filter('dgAmtToFeeAmountWith', dgAmtToFeeAmountWith)
  Vue.filter('orderProductAmountNTD', orderProductAmountNTD)
  Vue.filter('orderFeeAmountNTD', orderFeeAmountNTD)
  Vue.filter('orderDisplayExchRate', orderDisplayExchRate)
}
